import React from 'react'
import IconCheck from '@assets/_check.svg'
import { Button } from '@components/v2/button'
import Modal from '@components/shared/modal'

interface Props {
  setShowModal: (value) => void
  showModal: boolean
}

export const SuccessModal = ({ setShowModal, showModal }: Props) => {
  return (
    <Modal setShowModal={setShowModal} showModal={showModal}>
      <div className="px-4 md:px-9 py-12 md:py-8 flex flex-col justify-center items-center">
        <div className="flex w-full flex-1">
          <p className="font-workSans text-base md:text-lg text-v2-sonic-silver mb-7 text-left">
            OBRIGADO!
          </p>
        </div>
        <div className="flex flex-col justify-center items-center flex-1">
          <p className="font-workSans text-center text-lg md:text-3xl font-normal mb-2 md:px-2 lg:px-16">
            Seus Dados Foram Enviados Com Sucesso
          </p>
          <p className="font-workSans text-center text-lg md:text-3xl font-normal mb-12 md:px-2 lg:px-16">
            Em Breve{' '}
            <span className="font-semibold text-orange">
              Entraremos em Contato
            </span>
          </p>

          <div className="mb-24">
            <IconCheck />
          </div>
        </div>
        <div className="w-full flex flex-1 justify-center items-end">
          <div className="px-7 w-full md:w-80">
            <Button
              type="button"
              color="primary"
              className="rounded-4xl w-full"
              onClick={() => setShowModal(false)}
            >
              Fechar
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  )
}
